import eventEmitter from 'eventemitter3'

const NewMessageEvent = new eventEmitter()

export default NewMessageEvent
